export function useListIcons() {
  const iconOptions = [
    'heart',
    'ghost',
    'sparkles',
    'campfire',
    'dragon',
    'dice',
    'ring',
    'staff',
    'wand',
    'sword',
    'puzzle',
    'game-board',
    'chess-knight',
    'cards',
    'user-secret',
    'bug',
    'box-archive',
    'pen-fancy',
    'stamp',
    'stapler',
    'music',
    'volume',
    'play',
    'forward',
    'volume-slash',
    'film',
    'headphones',
    'ticket',
    'tv-retro',
    'star'
  ]

  return { iconOptions }
}
